import React, {Component} from 'react';
import {withRouter} from "react-router";
import {connect} from "react-redux";
import * as actions from "../../actions/ordersAction";
import {bindActionCreators} from 'redux';
import ProductVerifyCardComponent from "./ProductVerifyCardComponent";
import CommonHeaderComponent from "../headers/CommonHeaderComponent";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import * as symbols from "../../operations/symbols";
import LoaderComponent from "../core/LoaderComponent";

class VerifyOrderComponent extends Component {
  
  
  constructor(props) {
    super(props);
    this.state = {
      products: [],
      orderDetails: {
        originalPrice: 0,
        updatedPrice: 0
      }
    }
    
  }
  
  componentDidMount() {
    this.props.actions.getOrderProducts(this.props.match.params.id)
  }
  
  componentDidUpdate(prevProps, prevState, snapshot) {
    const {orders, getOrderProductsStatus} = this.props;
    if (orders.orderProducts && getOrderProductsStatus !== prevProps.getOrderProductsStatus && getOrderProductsStatus === symbols.STATUS_DONE) {
      
      let totalOriginalPrice = 0;
      let totalUpdatedPrice = 0;
      orders.orderProducts.forEach((ele) => {
        const netGstOrdered = ele.pricePerUnit * (ele.quantityDispatched) * ele.gstRate / 100;
        const grossPriceOrdered = ele.pricePerUnit * (ele.quantityDispatched) + netGstOrdered;
        
        let qtyDelivered = ele.issue !== null ? ele.issue.quantityDelivered : ele.quantityDispatched;
        
        const netGstUpdated = ele.pricePerUnit * (qtyDelivered) * ele.gstRate / 100;
        const grossPriceUpdated = ele.pricePerUnit * (qtyDelivered) + netGstUpdated;
        
        totalOriginalPrice += grossPriceOrdered;
        totalUpdatedPrice += grossPriceUpdated;
      });
      this.setState({
        products: orders.orderProducts,
        orderDetails: {originalPrice: totalOriginalPrice, updatedPrice: totalUpdatedPrice}
      })
    }
  }
  
  handleVerifyCLick() {
    const id = this.props.match.params.id;
    
    if (this.props.location.state && this.props.location.state.paymentMode === 'COD') {
      this.props.history.push({
        pathname: '/order/' + id + "/cod",
        state: {cash: this.state.orderDetails.updatedPrice , orderNumber:this.props.location.state.orderNumber}
      })
    } else {
      this.props.history.push({
        pathname: '/order/' + id + "/verifyDelivery",
        state: {orderNumber:this.props.location.state.orderNumber}
      })
    }
  }
  
  render() {
    const id = this.props.match.params.id;
    return (
      <div>
        {
          !this.props.location.state ?
            <div>
              <CommonHeaderComponent title={`Products`} enableBack={true}/>
              <div className="pd-top-global fs-18 red-text center">
                Unauthorized!!!
              </div>
            </div>
            :
            <div>
              <CommonHeaderComponent title={`${this.props.location.state.orderNumber} - Products`} enableBack={true}/>
              {
                this.props.getOrderProductsStatus === symbols.STATUS_BEGIN ?
                  <div className='pd-top-global'>
                    <LoaderComponent/>
                  </div>
                  :
                  <div className='pd-top-global gray-wrap pd-bottom-global mh-100'>
                    <div className=" verify-top-header">
                      <div className="fs-14 vertical-align-middle">Have issues?</div>
                      <div
                        className="btn btn-green-flat btn-green"
                        onClick={() => this.props.history.push({
                          pathname: '/order/' + id + '/products',
                          state: {orderNumber:this.props.location.state.orderNumber}
                        })}
                      >
                        Record Issues
                      </div>
                    </div>
                    <React.Fragment>
                      {
                        this.state.products.map((ele) =>
                          <ProductVerifyCardComponent
                            product={ele}
                            key={ele.id}
                          />
                        )
                      }
                    </React.Fragment>
                    <div className="order-card mt-2">
                      <div
                        className={"btn btn-expand btn-green "}
                        onClick={() => this.props.history.push({
                          pathname: '/order/' + id + '/products',
                          state: {orderNumber:this.props.location.state.orderNumber}
                        })}
                      >
                        Record Issues
                      </div>
                    </div>
                    <div className="order-card fixed-verify-section">
                      <div className="">
                        Org. Price: <b>&#8377;{this.state.orderDetails.originalPrice}</b> <br/>
                        Upd. Price: <b>&#8377;{this.state.orderDetails.updatedPrice} </b>
                      </div>
                      <div
                        className={"btn btn-green-flat btn-green "}
                        onClick={() => this.handleVerifyCLick()}
                      >
                        Mark Delivered
                      </div>
                    </div>
                  </div>
              }
            </div>
        }
      </div>
    )
  }
  
}

export default withRouter(connect(
  state => ({
    getOrderProductsStatus: state.statuses.getOrderProducts.status,
    getOrderProductError: state.statuses.getOrderProducts.error,
    orders: state.orders,
  }),
  dispatch => ({
    actions: bindActionCreators(actions, dispatch),
  }),
)(VerifyOrderComponent));

